import { z } from 'zod'
import { InstallationDescriptor, HandoverPrepareRequest, HandoverBundle } from './show-handover.js'
import { ShowPackageImportRequest } from './show-package-import.js'

export const DeliveryKey = z.uuid()
export const DeliveryEnvelope = z.strictObject({
  format: z.literal('honeyshow-delivery.v1'),
  deliveryKey: DeliveryKey,
  from: InstallationDescriptor,
  to: InstallationDescriptor,
  content: z.discriminatedUnion('kind', [
    z.strictObject({ kind: z.literal('copy'), package: z.unknown() }),
    z.strictObject({ kind: z.literal('request'), preparation: HandoverPrepareRequest }),
    z.strictObject({ kind: z.literal('bundle'), bundle: HandoverBundle }),
  ]),
})
export const DeliveryChoices = ShowPackageImportRequest.omit({ package: true, baselines: true })
export const DeliveryCreate = z.strictObject({
  deliveryKey: DeliveryKey,
  peerId: z.string().min(1).max(64),
  showId: z.string().min(1).max(256),
  kind: z.enum(['copy', 'request']),
  privacyProfile: z.enum(['limited', 'full-contact']).default('limited'),
})
export const DeliveryStatus = z.strictObject({
  deliveryKey: DeliveryKey,
  artifactDigest: z.string(),
  direction: z.enum(['incoming', 'outgoing']),
  kind: z.enum(['copy', 'request', 'bundle']),
  peerId: z.string(),
  state: z.enum(['staged', 'prepared', 'committed', 'cancelled', 'discarded', 'expired']),
  provenance: z.enum(['https', 'file', 'local']),
  expiresAt: z.iso.datetime(),
  receipt: z.unknown().nullable(),
  preparationAvailable: z.boolean(),
})
export const DeliveryPage = z.strictObject({
  deliveries: z.array(DeliveryStatus),
  nextCursor: z.uuid().nullable(),
})
export const DeliveryReview = z.strictObject({
  envelope: DeliveryEnvelope,
  choices: DeliveryChoices,
})
export const DeliveryApply = DeliveryReview.extend({ reviewToken: z.uuid() })
export type TDeliveryEnvelope = z.infer<typeof DeliveryEnvelope>
export type TDeliveryStatus = z.infer<typeof DeliveryStatus>
